export default "__VITE_ASSET__Q$ZMF3_t__"